import React, { Component } from 'react'
import t from 'tcomb-form'
import cn from 'classnames'
import { Link } from 'react-router-dom'
import {connect} from 'react-redux'
import FormUtils from '../lib/FormUtils'
import { push } from '../history'
import { create } from '../actions/account'
import { checkEmail } from '../actions/auth'
import { alert } from '../actions/alerts'

import Loading from '../components/Loading'

@connect(null)
export default class Signup extends Component {
  state = {
    ...this.getSchema({}),
    value: {},
    loading: false
  }

  getSchema ({emailError}) {
    return FormUtils.getForm({
      name: {
        type: 'string',
        config: {type: 'login'},
        attrs: {placeholder: 'Your Name'},
        required: true
      },
      email: {
        type: 'string',
        config: {type: 'login'},
        hasError: !!emailError,
        error: emailError,
        attrs: {
          type: 'email',
          placeholder: 'Email Address',
          onBlur: this.checkEmail
        },
        required: true
      },
      password: {
        type: 'string',
        config: {type: 'login'},
        attrs: {type: 'password', placeholder: 'Password'},
        required: true
      }
    })
  }

  onSubmit = async (e) => {
    e.preventDefault()
    this.setState({loading: true})
    const {dispatch} = this.props

    const {data: {account}} = await dispatch(
      create({...this.state.value, billing_plan: 'free'})
    )
    if (account.error) {
      this.setState({hasError: true, loading: false})
      dispatch(alert({message: account.error.message, type: 'error'}))
    } else {
      dispatch(alert({message: 'Account created. Please log in.', type: 'success'}))
      push('/login')
    }
  }

  onChange = (value) => this.setState({hasError: false, value})

  checkEmail = async (e) => {
    const {value: {email}} = this.state
    const isValid = await checkEmail(email)
    this.setState({
      ...this.getSchema({emailError: isValid ? null : 'Email is invalid or already taken'})
    })
  }

  render () {
    const {schema, options, value, loading} = this.state
    const className = cn({hasError: this.state.hasError})

    const formOptions = {
      ...options,
      template: (locals) => {
        return <div>
          <fieldset className='field-group'>
            {locals.inputs.site_name}
          </fieldset>
          <fieldset className='field-group'>
            {locals.inputs.name}
            {locals.inputs.email}
            {locals.inputs.password}
          </fieldset>
        </div>
      }
    }

    return <div className='absolute-center login-window'>
      <div className='branding-logo' />
      <h1>Get started with Fridge</h1>
      <form onSubmit={this.onSubmit} className={className} autoComplete='off'>
        <t.form.Form type={schema} options={formOptions} value={value} onChange={this.onChange} />
        <button type='submit' className='login-btn'>{loading ? <Loading /> : 'Create Account'}</button>
        <Link to='/login'>Already have an account?</Link>
      </form>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/containers/Signup.js